import { gql } from "@apollo/client";

export default gql`
mutation UpdatePassword($userId: ID!, $password: String) {
  updatePassword(userId: $userId, password: $password) {
    user_name
  }
}
`